import Cookies from 'js-cookie';
import axios from 'axios';

export const callLoginApi = async (
  endpoint,
  method = 'GET',
  data = null,
  onSuccess,
  headers,
  params
  //   setRefreshCaptcha,
  //   setLawForUser,
  //   setCookieToken
) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_BASE_URL_PROFILE}${endpoint}`, // api address
      method, // type of request (get,post,...)
      ...(data && { data }), // if data or params exists
      ...(params && { params }),
      ...(headers && { headers }),
    });

    // setLoading(false);
    console.log(response);

    if (
      // response[0] === "Password : The Password field is required." ||
      // response[0] === "user not found" ||
      // response[0] === "UserName : The UserName field is required." ||
      // response[0] === "you should go to the login." ||
      // response[0] === "invalid informatiom." ||
      response.data.statusCode !== 200
    ) {
      alert('نام ورود یا کلمه عبور اشتباه است، لطفا دوباره تلاش کنید.');
      //   setRefreshCaptcha(true);
    } else {
      const cookieOptions = {
        expires: 365 * 100, // 100 years
        secure: process.env.REACT_APP_COOKIE_SECURE === 'true',
        sameSite: process.env.REACT_APP_COOKIE_SAMESITE || 'strict',
      };

      // Add domain attribute if specified in .env
      if (process.env.REACT_APP_COOKIE_DOMAIN) {
        cookieOptions.domain = process.env.REACT_APP_COOKIE_DOMAIN;
      }

      // Set the cookie
      Cookies.set('token', `${JSON.stringify(response.data)}`, cookieOptions);
      onSuccess(response.data);
      //setCookieToken(response.data);
    }
    return response.data;
  } catch (error) {
    console.log('errorFetchLoginJWT: ', error);
  }
};
